import { createFileRoute } from '@tanstack/react-router'

import { CoreSkillsAssessmentStepResultsInitial } from '@/core-skills-assessment/components/CoreSkillsAssessmentStepResultsInitial/CoreSkillsAssessmentStepResultsInitial'

export const Route = createFileRoute('/skills-assessment/results-initial')({
  component: CoreSkillsAssessmentStepResultsInitial,
})
